import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';

interface IDespawnAllButtonProps {
	onDespawn?: () => Promise<void>;
}

const DespawnAllButton = ({ onDespawn }: IDespawnAllButtonProps = {}) => {
	const handleDestroyAll = async () => {
		try {
			if (onDespawn) {
				await onDespawn();
			} else {
				await rage.vehicles.destroyAllPlayerVehicles();
			}
		} catch (error) {
			rage.notifications.showException(error);
		}
	};

	return (
		<Button
			color={ButtonColors.Default}
			height={ButtonHeight.Height20}
			borderRadius={ButtonBorderRadius.Radius5}
			onClick={handleDestroyAll}
			style={{
				position: 'absolute',
				right: 0,
				width: 'fit-content',
				padding: '0 5px',
			}}
		>
			<Text>Убрать все</Text>
		</Button>
	);
};

export { DespawnAllButton };
